import axios from 'axios';
import { ROOT_URL } from '../globals';

export const FETCH_MEAS_LIST_BEGIN   = 'FETCH_MEAS_LISTA_BEGIN';
export const FETCH_MEAS_LIST_SUCCESS = 'FETCH_MEAS_LIST_SUCCESS';
export const FETCH_MEAS_LIST_FAILURE = 'FETCH_MEAS_LIST_FAILURE';

export const fetchMeasureListBegin = () => ({
    type: FETCH_MEAS_LIST_BEGIN
  });
  
  export const fetchMeasureListSuccess = AcctItems => ({
    type: FETCH_MEAS_LIST_SUCCESS,
    payload:  AcctItems 
  });
  
  export const fetchMeasureListFailure = error => ({
    type: FETCH_MEAS_LIST_FAILURE,
    payload: error
  });
  
  export default function fetchMeasureList() {
    return dispatch => {
      const url = `${ROOT_URL}RefData/GetMeasureList`;
      dispatch(fetchMeasureListBegin())
      axios.get(url)
        .then (function(result) {
            dispatch(fetchMeasureListSuccess(result));
            return result;
      })
      .catch(error => dispatch(fetchMeasureListFailure(error)));
    };
  }
  


// WEBPACK FOOTER //
// ./src/actions/ref_data_actions.js